import router from '@/router'
import app from '../main'

function removeResource (Model, value, resource, route) {
  Model.delete(value).then((response) => {
    resource.data.splice(resource.data.indexOf(value), 1)
    app.$snotify.success('Successfully deleted.')

    // If route is the same as deleted resource we need to redirect to /articles
    if (router.currentRoute.params.id === value.id) {
      router.push({ name: route })
    }
  })
}

function activeResource (resources, key = 'id') {
  let id = parseInt(router.currentRoute.params[key])

  if (resources && resources.length > 0) {
    return resources.find((p) => p.id === id) || {}
  } else {
    return {}
  }
}

export {removeResource, activeResource}



// WEBPACK FOOTER //
// ./src/store/helpers.js